import { IState } from '../../../store';

export const getIsFavorite = (state: IState) => {
  return state.offerData.isFavorite;
};
